import { render, staticRenderFns } from "./UserShow.vue?vue&type=template&id=628ec32c&scoped=true&"
import script from "./UserShow.vue?vue&type=script&lang=js&"
export * from "./UserShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628ec32c",
  null
  
)

export default component.exports